<template>
    <tile class="zalog-leasing" link="zalog">
        <div class="zalog-leasing__header" slot="tileHeader">
            <tile-title icon="none">
                <span><i class="fas fa-lock"></i> Лизинг / Залоги</span>
            </tile-title>
            <app-switcher
                :leftClickHandler="toggle"
                :rightClickHandler="toggle"
            >
                <span slot="leftValue">Лизинг</span>
                <span slot="rightValue">Залоги</span>
            </app-switcher>
        </div>
        <div class="zalog-leasing__content" slot="tileContent">
            <leasing ref="leasingRef"  v-if="type === 'leasing'" :list="leasingList" />
            <zalog ref="zalogRef" v-if="type === 'zalog'" :list="zalogList" />
            <leasing-modal
                ref="leasingModal" 
                v-show="isLeasingModal" 
                @close="closeLeasingModal"  
                :list="leasingList"
                :printStyle="printStyle"
                :title="title" 
            />
            <zalog-modal
                ref="zalogModal" 
                v-show="isZalogModal"
                @close="closeZalogModal" 
                :list="zalogList" 
                :pagination="zalogPagination"
                :printStyle="printStyle"
                :title="title"  
            />
        </div>
        <div 
            :class="{ 'flex-end': (!isLeasingBtn && type === 'leasing') || (!isZalogBtn && type === 'zalog') }" 
            class="zalog-leasing__footer" 
            slot="tileFooter"
        >
            <tile-button @click.native="openLeasingModal" v-if="isLeasingBtn">Все сообщения</tile-button>
            <tile-button @click.native="openZalogModal" v-if="isZalogBtn">Все уведомления ({{zalogTotalCount}})</tile-button>
            <tilePrintPdf
                :html="htmlContent"
                :title="title" 
                :filename="filename"
                :printStyle="printStyle"
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import tileButton from '@/components/ui/tileButton/tileButton.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import leasing from '@/components/card/zalogLeasing/leasing/leasing.vue'
import leasingModal from '@/components/card/zalogLeasing/leasing/leasingModal.vue'
import zalog from '@/components/card/zalogLeasing/zalog/zalog.vue' 
import zalogModal from '@/components/card/zalogLeasing/zalog/zalogModal.vue' 

export default {
    components: {
        tile,
        demoMessage,
        tileTitle,
        appSwitcher,
        tileButton,
        tilePrintPdf,
        leasing,
        leasingModal,
        zalog,
        zalogModal
    },
    data: () => ({
        type: 'leasing',
        isLeasingModal: false,
        isZalogModal: false,
        leasingHtml: '',
        zalogHtml: '',
        printStyle: `
            body { max-width: 1240px !important; font-family: Times New Roman !important; }
            .print-main-title {
                display: block;
                width: 100%;
                max-width: 1280px;
                border-bottom: 1px solid #4b6365;
                color: #4b6365;
                font-size: 25px;
                margin: 0 auto;
                text-align: center;
                margin-bottom: 15px;
                margin-top: 20px;
                font-family: Times New Roman !important;
                font-weight: 700 !important;
            }
            #print-content {
                font-size: 14px;
                border-radius: 10px;
            }
            ul.list { background: #eeeeef; border-radius: 10px; padding: 0; color: #000; font-family: unset !important; }
            li.item { padding: 0; margin-bottom: 15px; border-bottom: 1px solid #ddd; padding: 10px 20px 10px 20px; }
            .subjects-table {
                width: 98%;
	            margin: 8px 0 8px 0;
            }
            .subjects-table td, .subjects-table th {
                padding: 4px 4px;
                border-bottom: none;
                text-align: left;
                border: none;
                border-collapse: separate;
            }
            .subjects-table td:not(:last-child) { width: 30%; }
            .subjects-table th:not(:last-child) { width: 30%; }
            .green { color: #27ae60; }
            .red { color: #e74c3c; }
            .table-title.fz-20 { font-size: 20px; font-weight: 700; color: #000; }
            .table.modal-table { border-collapse: collapse; font-family: "Lucida Sans Unicode", "Lucida Grande", Sans-Serif; }
            .table.modal-table th, .table.modal-table .first-column { background: #ddddde; }
            .table.modal-table td, .table.modal-table th { padding: 10px 20px; border: 1px solid #000; text-align: center; color: #000; }
            .table.modal-table td.w-30 { width: 60% !important;  word-break: break-word; } 
            .table.modal-table td.w-40 { width: 1%; } 
            .table-title.fz-20 {
                font-family: "Lucida Sans Unicode", "Lucida Grande", Sans-Serif;
                font-size: 20px;
                font-weight: 700;
            }
            .table.modal-table th {
                padding: 10px 20px;
                white-space: nowrap;
                color: #000;
            }
            .item div { 
                margin-bottom: 8px;
            }
        `
    }),
    computed: {
        leasingList() { return this.$store.state.card?.zalogLeasing?.leasing?.list },
        zalogList() { return this.$store.state.card?.zalogLeasing?.zalog?.list },
        isLeasingBtn() { return (this.type === 'leasing' && this.leasingList.length > 0) },
        isZalogBtn() { return (this.type === 'zalog' && this.zalogList.length > 0) },
        zalogTotalCount() { return this.$store.state.card?.zalogLeasing?.zalog?.totalCount },
        zalogPagination() { return this.$store.state.card?.zalogLeasing?.zalog?.pagination },
        companyType() { return this.$store.state.card?.company?.type || 'ul' },
        IPname() { return this.$store.state.card?.company?.head_fio },
        companyName() {
            if(this.companyType === 'ul') {
                return this.$store.state?.card?.company?.name_short || this.$store.state?.card?.company?.name_full
            } else if(this.companyType === 'ip') {
                return this.IPname ? ` ИП ${this.IPname}` : this.$store.state.card?.company?.title
            }
        },
        htmlContent() { return this.type === 'leasing' ?  this.leasingHtml : this.zalogHtml },
        title() { return this.type === 'leasing' ? `Лизинг | ${this.companyName}` : `Залоги | ${this.companyName}` },
        filename() { return this.type === 'leasing' ? 'Leasing' : 'Zalog' }
            
    },
    methods: {
        toggle() {
            this.type = this.type === 'leasing' ? 'zalog' : 'leasing'
            $('#tiles').trigger('resize')
        },
        openLeasingModal() { this.isLeasingModal = true },
        closeLeasingModal() { this.isLeasingModal = false },
        openZalogModal() { this.isZalogModal = true },
        closeZalogModal() { this.isZalogModal = false }
    },
    watch: {
        leasingList() {
            setTimeout(() => {
                this.leasingHtml = this.$refs.leasingModal?.$refs?.leasingModalContent?.outerHTML
            }, 500)
        },
        zalogList() {
            setTimeout(() => {
                this.zalogHtml = this.$refs.zalogModal?.$refs?.zalogModalContent?.outerHTML
            }, 500)
        }
    },
    mounted() {
        this.$store.dispatch('card/zalogLeasing/getLeasingInfo', { limit: 15, offset: 0 })  
        this.$store.dispatch('card/zalogLeasing/getZalogData', { limit: 10, offset: 0 })  
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'
.zalog-leasing
    overflow-y: visible
    overflow-x: visible
    &__header
        @include flex-between
    &__content
        margin-top: 15px
    &__footer
        margin-top: 15px
        @include flex-between
    .flex-end
        justify-content: flex-end
</style>